import { spawn, put, call, fork, all, select, takeLatest } from "redux-saga/effects";
import { delay } from 'redux-saga/effects';
import { userAuthenticate, userRefresh, isLoggedInPost2 } from "../api/ssoApi";
import * as types from "../constants/actionTypes";
import * as msgs from "../constants/textConstants";
import { proxyInfo, getEvisitEligibility, getZipnosisEvisitUrl, getMyChartStatus, getCareCompanionEnrollStatus } from '../api/epicApi';
import { getNotices, getConsents } from '../api/portalApi';
import { logToAndylitics } from "../api/andyliticsApi";
import * as portalAPI from "../api/portalApi";
import * as account from "../api/accountApi";
import * as Tools from "../helpers/Tools";
const Interactive_InApp_Tutorial = 'InteractiveInAppTutorial';  //cookie name for Interactive In App Site Tour
import Cookies from "cookies-js";
import { logAPI } from "../api/andyliticsApi";
import { getThrive } from "../api/portalApi";
import { getDomain } from "../helpers/Tools";
import { convertZipnosisErrorMessage } from "../helpers/data";
import { getEpicWhoCanManageYou } from '../api/proxyApi';
import { getFCHPUserData, getUserPayerData } from "../api/healthPlanServicesApi";
import { getHealthPlans } from "../api/healthPlanApi";
import * as hpServicesApi from "../api/healthPlanServicesApi";
import { getMembershipData, refreshProfile } from "../api/mybswBFFApi";
import * as todosSaga from "./todosSaga";
import * as prayerFeatureSaga from "./prayerFeatureSaga";
import { RecompileProfile } from "../api/membershipsApi";



const AALinkModalExpire = '_aalinkingmodalexpire';

export function* watchUserAuthenticate() {
    yield takeLatest([types.USER_AUTHENTICATE], authorize);
    yield takeLatest([types.USER_AUTHENTICATE_REFRESH], refresh);
    yield takeLatest([types.ON_USER_AUTHENTICATE_SUCCESS], onUserAuthenticateSuccess)
    yield takeLatest([types.VERIFY_LOGIN], verifyLogin);
    yield takeLatest([types.LOGOUT], logoutRedirect);
    yield takeLatest([types.LOGIN_FORM_SUCCESS], loginSuccess);
    yield takeLatest([types.REFRESH_TOKEN], refreshToken);
    yield takeLatest([types.LOAD_TERMS_AND_CONDITIONS], loadTermsAndConditions);
    yield takeLatest([types.ACCEPT_TERMS_AND_CONDITIONS], acceptTermsAndConditions);
    yield takeLatest([types.SAVE_HIDE_TUTORIAL], saveShowTutorial);
    yield takeLatest([types.ZIPNOSIS_EVISIT_URL], zipnosisEvisitUrl);
    yield takeLatest([types.REFRESH_PROXY_LIST], refreshProxyList);
    yield takeLatest(types.SWITCH_USER_SAGA, handleUserSwitch);
    yield takeLatest([types.MEMBERSHIP_GET_START], refreshProfileData);
    yield takeLatest([types.MEMBERSHIP_TIMER_START], startMembershipTimer);
    yield takeLatest([types.REFRESH_FAMILY_MANAGEMENT_TOOLTIP], refreshFamilyManagementTooltip);
}



export function* refreshProfileData(data) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        var memberData = null;
        var token = data.t || domain.t;
        if (token) {
            memberData = yield Tools.safeCall(getMembershipData, token);
        }
        logAPI("MBHWeb.Saga.SSO.GotProfile", start, null, memberData);
        if (memberData === null || memberData && memberData.err) {
            yield put({ type: types.MEMBERSHIP_GET_FAILURE, error: memberData && memberData.err ? memberData.err : null });

            if (window.serverData.data.replaceProxyInfoWithMemberships) {
                yield todosSaga.handleAction({ type: types.PROXY_LIST_FAILURE, error: "Failed proxy from memberships" });
            }
            if (data && data.callback) {
                data.callback(memberData, false);
            }

            window.store.dispatch({ 
                type: types.GET_PATIENT_SCHEDULING_PERMISSIONS_SUCCESS,
                schedulingPermissions: {
                    loadedSchedulingPermissions: true,
                    isFetching: false,
                    error: null
                }
            });
        }
        else {
            //debugger;
            yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: memberData.result });
            yield todosSaga.handleAction({ type: types.PROXY_LIST_LOADED });

            if (data && data.callback) {
                data.callback(memberData, true);
            }
        }
        logAPI("MBHWeb.Saga.SSO.RefreshProfile", start, null, data);
    }
    catch (ex) {
        if (data && data.callback) {
            data.callback(ex, false);
        }
        logAPI("MBHWeb.Saga.SSO.RefreshProfile.Failure", start, null, data);
        console.error(ex);
    }
}

// the profile is fetched every x seconds (time set by slot config)
export function* startMembershipTimer(data) {
    try {
        let currentProfile = yield select((state) => state.memberships);
        const domain = yield select((state) => state.domain);
        let time = window.serverData.data.membershipRefreshInSeconds;

        Tools.safeCall(refreshProfile, domain.t),   // this is the /login call that triggers the full rediscovery... fast async acknowledgement and return

        yield spawn(recompileRetryLoop,  domain.t, time);

        //yield call(refreshProfileData, domain.t);
        yield delay(time * 1000);
        yield call(refreshProfileData, domain.t);  // this line is in here on a timer to pick up possible discovery from new user registrations that weren't completed at the time they first click in from the registration page

    }
    catch (e) {
        console.log(e);
    }
}

export function* recompileRetryLoop(token, waitTime) {
    var iCurr = 0;
    try {
        while (iCurr < 5) { // we'll repeat the try up to 5 times if there is an error
            var results = yield Tools.safeCall(RecompileProfile, token);  // this is the synchronous /recompile
            if (results && !results.err && results.result) {
                yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: results.result });
                yield todosSaga.handleAction({ type: types.PROXY_LIST_LOADED });
                break;
            }
            else {
                yield delay(time * 1000);
            }
            iCurr++;
        }

    }
    catch (e) {
        console.error(e);
    }

}

export function* saveShowTutorial(data) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);

        yield Tools.safeCall(account.setHideTutorial, domain.t);
        logAPI("MBHWeb.Saga.SSO.ShowTutorial.Save", start, null, data);
    }
    catch (ex) {
        console.error(ex);
        logAPI("MBHWeb.Saga.SSO.ShowTutorial.Save.Failure", start, null, data);
    }
}

export function* loadTermsAndConditions() {
    const start = new Date();
    try {
        const terms = yield Tools.safeCall(portalAPI.getTermsAndConditions);

        if (!terms.err && terms.result && terms.result.isSuccessful) {
            yield put({ type: types.SET_TERMS_AND_CONDITIONS, terms: terms.result.textToDisplay, version: terms.result.versionId });
            let andyliticResponse = JSON.parse(JSON.stringify(terms));
            if (andyliticResponse && andyliticResponse.result && andyliticResponse.result.textToDisplay) {
                andyliticResponse.result.textToDisplay = '';
            }
            logAPI("MBHWeb.Saga.SSO.TermsAndConditions.Get", start, null, andyliticResponse);
        }


    }
    catch (e) {
        console.error(e);
        logAPI("MBHWeb.Saga.SSO.TermsAndConditions.Get.Failure", start, null);
    }

}

export function* handleRedirect(reDirectURL) {
    const start = new Date();
    const history = yield select((state) => state.session.history);
    var domain = yield select((state) => state.domain);
    if (typeof window !== 'undefined') {
        if (reDirectURL && window.location.pathname !== reDirectURL) {

            //alert("Redirecting to redir url: " + reDirectURL);
            const reDirectURLWithQP = domain.qp ? reDirectURL + domain.qp : reDirectURL;

            yield put({ type: types.CLEAR_REDIRECT_URL });

            domain = yield select((state) => state.domain);
            if (history) { history.push(reDirectURLWithQP) };
            logAPI("MBHWeb.Saga.SSO.Redirect", start, null, reDirectURLWithQP);
        }
        yield put({ type: types.CLEAR_REDIRECT_URL });

    }

}

export function* acceptTermsAndConditions(data) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);

        if (domain.li) {
            const accept = yield call(portalAPI.acceptTermsAndConditions, domain.t, domain.un, data.VersionID);
            const reDirectURL = window.redirectURL;

            yield put({ type: types.SET_TERMS_AND_CONDITIONS, HasAccepted: true });


            yield handleRedirect(reDirectURL);
            logAPI("MBHWeb.Saga.SSO.TermsAndConditions.Accept", start, null, JSON.stringify(accept));
        }
    }
    catch (ex) {

        console.error(ex);
        logAPI("MBHWeb.Saga.SSO.TermsAndConditions.Accept.Failure", start, null, null);
    }
}


export function* refreshToken() {
    const start = new Date();

    const domainData = yield select((state) => state.domain);

    if (domainData.rt) {
        yield put({ type: types.USER_AUTHENTICATE_REFRESH, refresh_token: domainData.rt });
        logAPI("MBHWeb.Saga.SSO.RefreshToken.Get", start, null);
    } else {
        //Adding more log to validate mobile issue for linking
        logAPI("MBHWeb.Saga.SSO.RefreshToken.Error.NoRefreshToken", start, null);
    }
}


export function* loginSuccess(paylog) {

    try {
        const sDomain = getDomain();
        Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
    }
    catch (err) {
        console.error(err);
    }

}


export function* authorize(payload) {
    const start = new Date();
    try {
        //debugger;
        const response = yield call(userAuthenticate, payload);

        //debugger;
        yield onUserAuthenticateSuccess(response);
        if (response && response.access_token) {
            //debugger;

            yield put({ type: types.LOGIN_FORM_SUCCESS, error: null, isWaiting: false });
            logAPI("MBHWeb.Saga.SSO.Authenticate.Login", start, null);
        }
        else {
            //debugger;
            logAPI("MBHWeb.Saga.SSO.Authenticate.Login.Failure", start, null, response);
        }
    }
    catch (error) {
        //debugger;
        //console.error(error);
        //console.log(JSON.stringify(error));
        logAPI("MBHWeb.Saga.SSO.Authenticate.Login.Failure", start, null, error);
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
        yield put({ type: types.USER_AUTHENTICATE_FAILURE, errorCode: error.message, userErrorMessage: error.message, responseError: error.message, isWaiting: false });
    }
}

export function* CallIsLoggedIn(payload) {
    const start = new Date();
    try {
        //debugger;
        const domain = yield select((state) => state.domain);

        const response = yield call(isLoggedInPost2, domain.t);

        yield onUserAuthenticateSuccess(response);
        logAPI("MBHWeb.Saga.SSO.IsLoggedIn", start, null, response);
    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.SSO.IsLoggedIn.Failure", start, null, null);
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }
}



var bInRefresh = false;

export function* refresh(payload) {
    const start = new Date();
    try {
        const response = yield call(userRefresh, payload);

        if (response && response.access_token) {
            //debugger;
            yield onUserAuthenticateSuccess(response);
            logAPI("MBHWeb.Saga.SSO.Refresh", start, null);
        }
        else {
            yield put({ type: types.REFRESH_TOKEN_FAILURE, userData: response, responseError: response.error, isWaiting: false });
            logAPI("MBHWeb.Saga.SSO.Refresh.Failure", start, null);
        }
        if (response && !response.IsLoggedIn) {
            yield put({ type: types.VERIFY_LOGIN, error: null, isWaiting: false });
            logAPI("MBHWeb.Saga.SSO.Refresh.Failure", start, null);
        }
        return response;
    }
    catch (error) {
        console.error(error);
        bInRefresh = false;
        logAPI("MBHWeb.Saga.SSO.Refresh.Failure", start, null, null);
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }

}


export function* loadHealthPlanMaintenanceEvents(token, memberId) {
    var hrMaintenanceEvents = yield call(hpServicesApi.ProcessControlEventsApi.getProcessControlEvents, token, memberId);
    yield put({ type: types.SET_HEALTHPLAN_MAINTENANCE_EVENTS, maintenanceEvents: hrMaintenanceEvents });
}

export function* onUserAuthenticateSuccess(response) {
    const session = yield select((state) => state.session);
    const start = new Date();
    try {
        if (response && response.access_token) {
            var iInstanceID = Math.floor(Math.random() * 1000);
            //debugger;
            const hasMyChart = response.Logins.indexOf('MyChart') > -1;
            const hasAutoMyChart = response && response.AUTO_MyChartID ? true : false;
            const enableAutoMyChartLink = typeof window !== 'undefined' && window.serverData.data.enableMyChartAutoLink;
            const showAccessAndProxiesList = typeof window !== 'undefined' && window.serverData.data.ShowAccessAndProxiesList;
            //const enableDCJSelfEnrollForWellness = typeof window !== 'undefined' && window.serverData.data.enableDCJSelfEnrollForWellness;
            const enableFluVaccine = typeof window !== 'undefined' && window.serverData.data.enableFluVaccine;
            const useRegistrationForUserPrefs = typeof window !== 'undefined' && window.serverData.data.useRegistrationForUserPrefs;
            const token = response.access_token;
            const userName = response.userName;
            const isEmployee = response.Logins.indexOf('Employee') > -1;
            const reDirectURL = window.redirectURL;

            // This dispatch loads the domain data but does not turn off the login spinner
            yield put({
                type: types.USER_AUTHENTICATE_SUCCESS,
                userData: response,
                responseError: response.error,
                isWaiting: true
            });


            yield put({ type: types.VERIFY_LOGIN_COMPLETED });  // turn on flag to do BYE page on next Login page

            //Get Health Plans
            const consentList = yield Tools.safeCall(getConsents, token);
            //debugger;
            if (!consentList.err && consentList.result.isSuccessful) {
                consentList.result.consentList.forEach((consent, index) => {
                    consent.data = JSON.parse(consent.data);
                });
                yield put({ type: types.HP_CONSENT_LIST, consentList: consentList.result.consentList });
            }
            const healthPlans = yield Tools.safeCall(getHealthPlans, token);
            let currentHealthPlan = null;
            if (healthPlans && !healthPlans.err && healthPlans.result) {
                logAPI("MBHWeb.Saga.SSO.GetHealthPlans.Success", start, null, null);
                if (healthPlans.result.length > 0) {
                    try {
                        if (healthPlans.result.length === 1) {
                            currentHealthPlan = healthPlans.result[0];
                        } else {
                            //If more health plans linked. Then Priority is AAL, else SWHP, First Care.
                            //Check for AAL.
                            currentHealthPlan = Tools.getHealthPlanByProviderKey(healthPlans.result, msgs.LOGIN_PROVIDER_AAL);
                            //Check for SWHP if we didn't find AAL.
                            if (currentHealthPlan === null) {
                                currentHealthPlan = Tools.getHealthPlanByProviderKey(healthPlans.result, msgs.LOGIN_PROVIDER_SWHP);
                            }
                            //Check for HR-SWHP if we didn't find above one.
                            if (currentHealthPlan === null) {
                                currentHealthPlan = Tools.getHealthPlanByProviderKey(healthPlans.result, msgs.LOGIN_PROVIDER_HR_SWHP);
                            }
                            //Check for FirstCare if we didn't find above one.
                            if (currentHealthPlan === null) {
                                currentHealthPlan = Tools.getHealthPlanByProviderKey(healthPlans.result, msgs.LOGIN_PROVIDER_FIRSTCARE);
                            }
                            //Take default one.
                            if (currentHealthPlan === null) {
                                currentHealthPlan = healthPlans.result[0];
                            }
                        }
                        let hasAMIDental = false;
                        var APIprefix = currentHealthPlan && currentHealthPlan.APIPrefix ? currentHealthPlan.APIPrefix : null;

                        if (APIprefix && APIprefix === "AMI") {
                            try {
                                //check first if is AMISYS user
                                const MemberId = currentHealthPlan && currentHealthPlan.ProviderKey ?
                                    currentHealthPlan.ProviderKey : null;
                                const hasDentalPlan = yield call(hpServicesApi.InvoiceApi.getDentalInvoiceDetails, token, MemberId);
                                if (hasDentalPlan) {
                                    hasAMIDental = true;
                                }

                            }
                            catch (e) {
                                console.log(e); //Call fails, user doesn't have a dental plan
                            }
                        }

                        let hrMaintenanceEvents = [];
                        try {
                            const MemberId = currentHealthPlan && currentHealthPlan.ProviderKey ?
                                currentHealthPlan.ProviderKey : null;
                            //Get Process Control Events
                            yield spawn(loadHealthPlanMaintenanceEvents, token, MemberId);
                            //hrMaintenanceEvents = yield call(hpServicesApi.ProcessControlEventsApi.getProcessControlEvents, token, MemberId);
                        }
                        catch (e) {
                            console.info(e)
                            //assume no process Control Events
                        }

                        logAPI("MBHWeb.Saga.SSO.GetHealthPlans.Plan.Found", start, null, { "LoginProvider": currentHealthPlan && currentHealthPlan.LoginProvider ? currentHealthPlan.LoginProvider : null });
                        yield put({ type: types.SET_HEALTHPLAN_INFO, healthPlanInfo: currentHealthPlan, healthPlans: healthPlans.result, hasADental: hasAMIDental });
                    } catch (e) {
                        console.log(e);
                        yield put({ type: types.SET_HEALTHPLAN_INFO, healthPlanInfo: currentHealthPlan, healthPlans: null, hasADental: false, maintenanceEvents: [] });
                        logAPI("MBHWeb.Saga.SSO.GetHealthPlans.Failure", start, null, null);
                    }
                } else {
                    yield put({ type: types.SET_HEALTHPLAN_INFO, healthPlanInfo: currentHealthPlan, healthPlans: null, hasADental: false, maintenanceEvents: [] });
                }
            } else {
                logAPI("MBHWeb.Saga.SSO.GetHealthPlans.Failure", start, null, null);
                yield put({ type: types.SET_HEALTHPLAN_INFO, healthPlanInfo: currentHealthPlan, healthPlans: null, hasADental: false, maintenanceEvents: [] });
            }

            const hpLoginProvider = currentHealthPlan && currentHealthPlan.LoginProvider ? currentHealthPlan.LoginProvider.toLowerCase() : '';
            const hasHealthPlan = hpLoginProvider && (hpLoginProvider === msgs.LOGIN_PROVIDER_SWHP ||
                hpLoginProvider === msgs.LOGIN_PROVIDER_HR_SWHP);

            yield put({
                type: types.GET_PRIVACY_MYBSWH_TEXT, featureId: msgs.Privacy_MyBswh,
                token: token });  // get digital privacy policy status.

            // check for all preferences of the user
            //debugger;
            const allPreferences = yield Tools.safeCall(account.getAllUserPreferences2, token);
            //debugger;
            const isAllPreferenceSuccess = allPreferences && !allPreferences.err && allPreferences.result; // && allPreferences.result.isSuccessful;
            const userPreferenceList = isAllPreferenceSuccess && allPreferences.result ? allPreferences.result : [];
            if (isAllPreferenceSuccess) {
                yield put({ type: types.SET_USER_PREFERENCES, userPreferences: userPreferenceList });
                logAPI("MBHWeb.Saga.SSO.GetAllUserPreferences.Get", start, null, JSON.parse(JSON.stringify(allPreferences)));
            }
            else {
                yield put({ type: types.SET_USER_PREFERENCES, userPreferences: null });
                logAPI("MBHWeb.Saga.SSO.GetAllUserPreferences.Get.Failure", start, null, allPreferences);
            }


            // For Auto-MyChart users validating preference to show Auto Link MyChart Popup
            if (!hasMyChart && hasAutoMyChart && enableAutoMyChartLink) {
                if (isAllPreferenceSuccess) {
                    const indexAutoMyChartPref = userPreferenceList.findIndex(preference => preference.PreferenceName === "DeclinedMyChart");
                    if (indexAutoMyChartPref >= 0) {
                        if (userPreferenceList[indexAutoMyChartPref].PreferenceValue === "true") {
                            yield put({
                                type: types.SHOW_AUTOLINK_MYCHART, showAutoLinkMyChart: false
                            });
                        }
                        else {
                            yield put({
                                type: types.SHOW_AUTOLINK_MYCHART, showAutoLinkMyChart: true
                            });
                        }
                        logAPI("MBHWeb.Saga.SSO.AutoLink.MyChart.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexAutoMyChartPref])));
                    }
                    else {
                        //preference not found in the list of Preferences so we are showing mychart auto linking modal.
                        yield put({
                            type: types.SHOW_AUTOLINK_MYCHART, showAutoLinkMyChart: true
                        });
                    }
                }
            }

            // For Add-Dependents Proxy Form           
            if (isAllPreferenceSuccess) {
                const indexAddProxiesPref = userPreferenceList.findIndex(preference => preference.PreferenceName === "DontPromptToAddProxies");
                if (indexAddProxiesPref >= 0) {
                    if (userPreferenceList[indexAddProxiesPref].PreferenceValue === "true") {
                        yield put({
                            type: types.SHOW_ADD_DEPENDENT_PROXY_FORM, showDependentProxyForm: false
                        });
                    }
                    else {
                        yield put({
                            type: types.SHOW_ADD_DEPENDENT_PROXY_FORM, showDependentProxyForm: true
                        });
                    }
                    logAPI("MBHWeb.Saga.SSO.AddDependents.Proxy.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexAddProxiesPref])));
                }
                //preference not found in the list of Preferences so we are showing add dependent proxy form.
                else {
                    yield put({
                        type: types.SHOW_ADD_DEPENDENT_PROXY_FORM, showDependentProxyForm: true
                    });
                }
            }

            // For VideoVisit ToolTip Preference           
            if (isAllPreferenceSuccess) {
                const indexVideoToolTipPref = userPreferenceList.findIndex(preference => preference.PreferenceName === "HideVideoVisitToolTipForWeb");
                //debugger;
                if (indexVideoToolTipPref >= 0) {
                    if (userPreferenceList[indexVideoToolTipPref].PreferenceValue === "true") {
                        yield put({
                            type: types.SHOW_VIDEO_VISIT_TOOLTIP, showVideoVisitToolTip: false
                        });
                    }
                    else {
                        yield put({
                            type: types.SHOW_VIDEO_VISIT_TOOLTIP, showVideoVisitToolTip: true
                        });
                    }
                    logAPI("MBHWeb.Saga.SSO.VideoVisitToolTip.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexVideoToolTipPref])));
                }
                //preference not found in the list of Preferences so we are showing videoVisitTooltip.
                else {
                    yield put({
                        type: types.SHOW_VIDEO_VISIT_TOOLTIP, showVideoVisitToolTip: true
                    });
                }
            }

            // For MapProxyRequesteeInfo Preference - New user registered and Requesting Pharmacy Access
            if (isAllPreferenceSuccess) {
                const indexProxyRequesteePref = userPreferenceList.findIndex(preference => preference.PreferenceName === "MapProxyRequesteeInfo");
                if (indexProxyRequesteePref >= 0) {
                    if (userPreferenceList[indexProxyRequesteePref].PreferenceValue && userPreferenceList[indexProxyRequesteePref].PreferenceValue !== "null") {
                        yield put({
                            type: types.SAVE_PROXY_REQUESTEE_INFO, proxyRequesteeInfo: userPreferenceList[indexProxyRequesteePref].PreferenceValue
                        });
                    }
                    else {
                        yield put({
                            type: types.SAVE_PROXY_REQUESTEE_INFO, proxyRequesteeInfo: null
                        });
                    }
                    logAPI("MBHWeb.Saga.SSO.MapProxyRequesteeInfo.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexProxyRequesteePref])));
                }
                //preference not found in the list of Preferences so we are setting null for proxyRequesteeInfo.
                else {
                    yield put({
                        type: types.SAVE_PROXY_REQUESTEE_INFO, proxyRequesteeInfo: null
                    });
                }
            }

            let showGetCareToolTip = null;
            // For GetCareToolTip Preference           
            if (isAllPreferenceSuccess) {
                const indexGetCareToolTipPref = userPreferenceList.findIndex(preference => preference.PreferenceName === msgs.HideGetCareToolTip);
                if (indexGetCareToolTipPref >= 0) {
                    if (userPreferenceList[indexGetCareToolTipPref].PreferenceValue === "true") {
                        showGetCareToolTip = false;
                        yield put({
                            type: types.SHOW_GET_CARE_TOOLTIP, showGetCareToolTip
                        });
                    }
                    else {
                        //showGetCareToolTip = true;
                        yield put({
                            type: types.SHOW_GET_CARE_TOOLTIP, showGetCareToolTip: false  //Disabling Tooltip
                        });
                    }
                    logAPI("MBHWeb.Saga.SSO.GetCareToolTip.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexGetCareToolTipPref])));
                }
                //preference not found in the list of Preferences so we are showing GetCareToolTip.
                else {
                    //showGetCareToolTip = true;
                    yield put({
                        type: types.SHOW_GET_CARE_TOOLTIP, showGetCareToolTip: false   //Disabling Tooltip
                    });
                }
            }

            // For Family Management Preference           
            if (isAllPreferenceSuccess) {
                const indexFamilyManagementToolTipPref = userPreferenceList.findIndex(preference => preference.PreferenceName === msgs.ShowFamilyManagementToolTip);
                //debugger;
                //if preference not found in the list of Preferences we are showing FamilyManagementToolTip.
                const showFamMgmtTooltip = indexFamilyManagementToolTipPref >= 0 ? userPreferenceList[indexFamilyManagementToolTipPref].PreferenceValue === "true" : true;
                const hasRedirect = reDirectURL ? reDirectURL !== '/' : false;
                if (showFamMgmtTooltip && !hasRedirect) {
                    yield put({
                        type: types.SHOW_FAMILY_MANAGEMENT_TOOLTIP, showFamilyManagementToolTip: false, hasRedirect //Disabling tooltip
                    });
                }
                else {
                    yield put({
                        type: types.SHOW_FAMILY_MANAGEMENT_TOOLTIP, showFamilyManagementToolTip: false, hasRedirect
                    });
                }
                if (indexFamilyManagementToolTipPref >= 0) {
                    logAPI("MBHWeb.Saga.SSO.FamilyManagementToolTip.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexFamilyManagementToolTipPref])));
                }
            }

            // For DCJSelfEnrollToolTip Preference            
            //if (enableDCJSelfEnrollForWellness && isEmployee && isAllPreferenceSuccess) {
            //    const indexDCJSelfEnrollPref = userPreferenceList.findIndex(preference => preference.PreferenceName === "HideDCJSelfEnrollToolTip");
            //    if (indexDCJSelfEnrollPref >= 0) {
            //        if (userPreferenceList[indexDCJSelfEnrollPref].PreferenceValue === "true") {
            //            yield put({
            //                type: types.SHOW_DCJ_SELF_ENROLL_TOOLTIP, showDCJSelfEnrollToolTip: false
            //            });
            //        }
            //        else {
            //            yield put({
            //                type: types.SHOW_DCJ_SELF_ENROLL_TOOLTIP, showDCJSelfEnrollToolTip: true
            //            });
            //        }
            //        logAPI("MBHWeb.Saga.SSO.DCJSelfEnrollToolTip.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexDCJSelfEnrollPref])));
            //    }
            //    //preference not found in the list of Preferences so we are showing DCJSelfEnrollToolTip.
            //    else {
            //        yield put({
            //            type: types.SHOW_DCJ_SELF_ENROLL_TOOLTIP, showDCJSelfEnrollToolTip: true
            //        });
            //    }
            //}

            // For dismissable when complete flu vaccine tile
            // Update every year
            let hideFluVaccineTile = false;
            if (enableFluVaccine) {
                if (isAllPreferenceSuccess) {
                    const indexHideFluVaccineTile = userPreferenceList.findIndex(preference => preference.PreferenceName === "HideFluTile2021");
                    if (indexHideFluVaccineTile >= 0 && userPreferenceList[indexHideFluVaccineTile].PreferenceValue === "true") {
                        hideFluVaccineTile = true;
                        logAPI("MBHWeb.Saga.SSO.HideFluVaccineTile.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexHideFluVaccineTile])));
                    }
                    yield put({
                        type: types.HIDE_FLU_VACCINE_TILE, hideFluVaccineTile: hideFluVaccineTile
                    });
                } else {
                    yield put({
                        type: types.HIDE_FLU_VACCINE_TILE, hideFluVaccineTile: hideFluVaccineTile
                    });
                }
            }

            let hidePhase1toPhase4ToolTips = false;
            if (isAllPreferenceSuccess) {
                const indexForHidePhase1toPhase4ToolTips = userPreferenceList.findIndex(preference => preference.PreferenceName === "HidePhase1toPhase4ToolTips");
                if (indexForHidePhase1toPhase4ToolTips >= 0 && userPreferenceList[indexForHidePhase1toPhase4ToolTips].PreferenceValue === "true") {
                    hidePhase1toPhase4ToolTips = true;
                    logAPI("MBHWeb.Saga.SSO.HidePhase1toPhase4ToolTips.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList)));
                }
            }

            let showOnBoardingPhaseOneToolTipWeb = false; //When a new patient registers in after Refresh Phase 2 has been released the onboarding tool tips for Phase 1 &2 on Web and Mobile are hidden.
            if (isAllPreferenceSuccess) {
                const indexOnBoardingPhaseOneToolTipWeb = userPreferenceList.findIndex(preference => preference.PreferenceName === "ShowOnBoardingPhaseOneToolTipWeb");
                if (indexOnBoardingPhaseOneToolTipWeb < 0 || (indexOnBoardingPhaseOneToolTipWeb >= 0 && userPreferenceList[indexOnBoardingPhaseOneToolTipWeb].PreferenceValue === "true")) {
                    if (hidePhase1toPhase4ToolTips) { //For New net users need to suppress Phase 1 tool tip.
                        yield put({ type: types.DISMISS_ONBOARDING_PHASEONE_TOOLTIP });
                    } else {
                        showOnBoardingPhaseOneToolTipWeb = true;
                        logAPI("MBHWeb.Saga.SSO.ShowOnBoardingPhaseOneToolTipWeb.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList)));
                    }
                }
                yield put({
                    type: types.SHOW_ONBOARDING_PHASEONE_TOOLTIP, showOnBoardingPhaseOneToolTipWeb: showOnBoardingPhaseOneToolTipWeb
                });
            } else {
                yield put({
                    type: types.SHOW_ONBOARDING_PHASEONE_TOOLTIP, showOnBoardingPhaseOneToolTipWeb: showOnBoardingPhaseOneToolTipWeb
                });
            }

            let showOnBoardingPhaseTwoToolTipWeb = false;
            if (isAllPreferenceSuccess) {
                const indexOnBoardingPhaseTwoToolTipWeb = userPreferenceList.findIndex(preference => preference.PreferenceName === "ShowOnBoardingPhaseTwoToolTipWeb");
                if (indexOnBoardingPhaseTwoToolTipWeb < 0 || (indexOnBoardingPhaseTwoToolTipWeb >= 0 && userPreferenceList[indexOnBoardingPhaseTwoToolTipWeb].PreferenceValue === "true")) {
                    if (hidePhase1toPhase4ToolTips) { //For New net users need to suppress Phase 2 tool tip.
                        yield put({ type: types.DISMISS_ONBOARDING_PHASETWO_TOOLTIP });
                    } else {
                        showOnBoardingPhaseTwoToolTipWeb = true;
                        logAPI("MBHWeb.Saga.SSO.ShowOnBoardingPhaseTwoToolTipWeb.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList)));
                    }
                }
                yield put({
                    type: types.SHOW_ONBOARDING_PHASETWO_TOOLTIP, showOnBoardingPhaseTwoToolTipWeb: showOnBoardingPhaseTwoToolTipWeb
                });
            } else {
                yield put({
                    type: types.SHOW_ONBOARDING_PHASETWO_TOOLTIP, showOnBoardingPhaseTwoToolTipWeb: showOnBoardingPhaseTwoToolTipWeb
                });
            }

            let showOnBoardingPhaseThreeToolTipWeb = false;
            if (isAllPreferenceSuccess) {
                const indexOnBoardingPhaseThreeToolTipWeb = userPreferenceList.findIndex(preference => preference.PreferenceName === "ShowOnBoardingPhaseThreeToolTipWeb");
                if (indexOnBoardingPhaseThreeToolTipWeb < 0 || (indexOnBoardingPhaseThreeToolTipWeb >= 0 && userPreferenceList[indexOnBoardingPhaseThreeToolTipWeb].PreferenceValue === "true")) {
                    if (hidePhase1toPhase4ToolTips) { //For New net users need to suppress Phase 3 tool tip.
                        yield put({ type: types.DISMISS_ONBOARDING_PHASETHREE_TOOLTIP });
                    } else {
                        showOnBoardingPhaseThreeToolTipWeb = true;
                        logAPI("MBHWeb.Saga.SSO.ShowOnBoardingPhaseThreeToolTipWeb.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList)));
                    }
                }
                yield put({
                    type: types.SHOW_ONBOARDING_PHASETHREE_TOOLTIP, showOnBoardingPhaseThreeToolTipWeb: showOnBoardingPhaseThreeToolTipWeb
                });
            } else {
                yield put({
                    type: types.SHOW_ONBOARDING_PHASETHREE_TOOLTIP, showOnBoardingPhaseThreeToolTipWeb: showOnBoardingPhaseThreeToolTipWeb
                });
            }

            let showOnBoardingPhaseFourToolTipWeb = false;
            if (isAllPreferenceSuccess) {
                const indexOnBoardingPhaseFourToolTipWeb = userPreferenceList.findIndex(preference => preference.PreferenceName === "ShowOnBoardingPhaseFourToolTipWeb");
                if (indexOnBoardingPhaseFourToolTipWeb < 0 || (indexOnBoardingPhaseFourToolTipWeb >= 0 && userPreferenceList[indexOnBoardingPhaseFourToolTipWeb].PreferenceValue === "true")) {
                    if (hidePhase1toPhase4ToolTips) { //For New net users need to suppress Phase 4 tool tip.
                        yield put({ type: types.DISMISS_ONBOARDING_PHASEFOUR_TOOLTIP });
                    } else {
                        showOnBoardingPhaseFourToolTipWeb = true;
                        logAPI("MBHWeb.Saga.SSO.ShowOnBoardingPhaseFourToolTipWeb.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList)));
                    }
                }
                yield put({
                    type: types.SHOW_ONBOARDING_PHASEFOUR_TOOLTIP, showOnBoardingPhaseFourToolTipWeb: showOnBoardingPhaseFourToolTipWeb
                });
            } else {
                yield put({
                    type: types.SHOW_ONBOARDING_PHASEFOUR_TOOLTIP, showOnBoardingPhaseFourToolTipWeb: showOnBoardingPhaseFourToolTipWeb
                });
            }

            let showLinkMedicalRecordPhaseOneToolTip = false;
            if (!hasMyChart && isAllPreferenceSuccess) {
                const indexLinkMedicalRecordPhaseOneToolTip = userPreferenceList.findIndex(preference => preference.PreferenceName === "ShowLinkMedicalRecord");
                if (indexLinkMedicalRecordPhaseOneToolTip < 0 || (indexLinkMedicalRecordPhaseOneToolTip >= 0 && userPreferenceList[indexLinkMedicalRecordPhaseOneToolTip].PreferenceValue === "true")) {
                    showLinkMedicalRecordPhaseOneToolTip = true;
                    logAPI("MBHWeb.Saga.SSO.ShowLinkMedicalRecordPhaseOneToolTip.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList)));
                }
                yield put({
                    type: types.SHOW_LINK_MEDICALRECORD_PHASEONE_TOOLTIP, showLinkMedicalRecordPhaseOneToolTip: showLinkMedicalRecordPhaseOneToolTip
                });
            } else {
                yield put({
                    type: types.SHOW_LINK_MEDICALRECORD_PHASEONE_TOOLTIP, showLinkMedicalRecordPhaseOneToolTip: showLinkMedicalRecordPhaseOneToolTip
                });
            }

            let termsAccepted = true;  //default set to 'true' to avoid any error/exceptions from the Terms API
            const terms = yield Tools.safeCall(portalAPI.getTermsAndConditions, userName, token);  // in the event of Terms and Conditions failures, continue to allow the user into the site           
            //debugger;
            if (!terms.err && terms.result && terms.result.isSuccessful) {
                termsAccepted = terms.result.isAccepted;
                yield put({ type: types.SET_TERMS_AND_CONDITIONS, terms: terms.result.textToDisplay, version: terms.result.versionId, HasAccepted: terms.result.isAccepted });
                let andyliticResponse = JSON.parse(JSON.stringify(terms));
                if (andyliticResponse && andyliticResponse.result && andyliticResponse.result.textToDisplay) {
                    andyliticResponse.result.textToDisplay = '';
                }
                logAPI("MBHWeb.Saga.SSO.TermsAndConditions.Get", start, null, andyliticResponse);
            }


            // Get user preferences
            //HideMyBSWHealth2Tutorial
            //const prefs = yield Tools.safeCall(account.getHideTutorial, token);
            var getHideIndex = userPreferenceList.findIndex(preference => preference.PreferenceName === "HideMyBSWHealth2Tutorial");
            if (getHideIndex > -1) { //!prefs.err && prefs.result && prefs.result.length > 0 && prefs.result[0].isSuccessful) {
                //debugger;
                yield put({ type: types.SET_HIDE_TUTORIAL, hideTutorialPrompt: true });
                // nahh... cookies would block the banner for other users on the same box
                //const expiration = new Date(new Date().getTime() + parseInt(InteractiveInAppTutorialExpirationInDays) * 1000 * 60 * 60 * 24);
                //Cookies.set(Interactive_InApp_Tutorial, true, { path: '/', 'expires': expiration });

            }
            else {
                //debugger;
                // Check Cookie
                const cookieCheck = Cookies.get(Interactive_InApp_Tutorial);
                if (cookieCheck && cookieCheck === "true") {
                    yield Tools.safeCall(account.setHideTutorial, token);
                    yield put({ type: types.SET_HIDE_TUTORIAL, hideTutorialPrompt: true });
                }
                else {
                    yield put({ type: types.SET_HIDE_TUTORIAL, hideTutorialPrompt: false });
                }
            }

            // Trigger bff to do an async profile rediscovery and recompile
            //yield Tools.safeCall(refreshProfile, token);


            // Start timer to refresh profile
            if (session == null || !session.profileDataLoaded) {

                yield put({ type: types.PROFILE_DATA_LOADED });

                // Get most recent profile
                const memberData = yield Tools.safeCall(getMembershipData, token);

                logAPI("MBHWeb.Saga.SSO.GotProfile", start, null, memberData);
                if (memberData == null || memberData && memberData.err) {
                    yield put({ type: types.MEMBERSHIP_GET_FAILURE, error: memberData && memberData.err ? memberData.err : null });
                }
                else {
                    yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: memberData.result });
                }

                yield spawn(startMembershipTimer, token);

            }


            // call getProxyInformation for eVisit info and load todo tile.
            if (hasMyChart) {
                const proxyInfoResult = yield Tools.safeCall(proxyInfo, userName, token);
                if (!proxyInfoResult.err && proxyInfoResult.result) {

                    yield put({ type: types.INITIATE_TODOS }); //Load Todo tile.

                    let eVisitResults = []
                    if (proxyInfoResult.result.AccessList) {
                        eVisitResults = proxyInfoResult.result.AccessList.map((res) => {
                            let obj = Tools.extractEVisitInfo(res);
                            obj.patientId = res.PatientIds.find(id => id.IDType === 'EXTERNAL');
                            obj.externalId = obj.patientId ? obj.patientId.ID.trim() : null

                            return obj
                        })
                    }

                    yield put({ type: types.EVISIT_GET_SUCCESS, eVisit: eVisitResults })
                    let andyliticResponse = JSON.parse(JSON.stringify(proxyInfoResult));
                    if (andyliticResponse && andyliticResponse.result && andyliticResponse.result.textToDisplay) {
                        andyliticResponse.result.textToDisplay = '';
                    }
                    logAPI("MBHWeb.Saga.SSO.LoadProxyList", start, null, andyliticResponse);
                } else {
                    yield put({ type: types.INITIATE_TODOS });
                    yield put({ type: types.EVISIT_GET_FAILURE, eVisit: [] });
                    logAPI("MBHWeb.Saga.SSO.LoadProxyList.Failure", start, null);
                }
            } else {
                yield put({ type: types.EVISIT_GET_SUCCESS, eVisit: [] })
            }



            let domain = yield select((state) => state.domain);

            if (window && window.serverData.data.enablePatientPhoto && domain.pl && domain.pl.length > 0) {
                yield put({ type: types.PATIENT_PHOTO_START });
            }

            //console.log("CARECOACH TILE DATA REQUEST FROM SSO SAGA");
            const currentUser = domain && domain.cu;
            if (currentUser && currentUser.ei) {
                yield call(careCompanion, currentUser.ei);
            }

            //yield put({ type: types.LOAD_BFF_DASHBOARD_START });

            if (!window?.serverData?.data?.enableV2MembershipLinking) {
                if (currentHealthPlan && currentHealthPlan.Auto) {
                    const modalAutoHPExpireKey = currentHealthPlan.LoginProvider && currentHealthPlan.LoginProvider.toLowerCase().indexOf('auto-aal') > -1 ?
                        AALinkModalExpire : "_" + currentHealthPlan.LoginProvider + "_" + msgs.LinkModalExpire;
                    const cookieCheck = Cookies.get(response.userName + modalAutoHPExpireKey);
                    if (!cookieCheck || cookieCheck === false) {
                        logAPI("MBHWeb.Saga.SSO.HealthPlan.AutoLink.Show", start, null);
                        yield put({ type: types.SET_HIDE_AUTO_HP_LINKMODAL, showAutoHPLinkModal: true });
                    } else {
                        logAPI("MBHWeb.Saga.SSO.HealthPlan.AutoLink.Hide", start, null);
                        yield put({ type: types.SET_HIDE_AUTO_HP_LINKMODAL, showAutoHPLinkModal: false });
                    }
                }
            }

            if (domain.lt === null || domain.lt === 0) {
                yield put({ type: types.GEOLOCATION });
            }

            const history = yield select((state) => state.session.history);
            //const reDirectURL = window.redirectURL;

            var isMobile = false;
            try {
                isMobile = domain.mq;

            }
            catch (EE) {

            }

            //Determine if user has completed Onboarding 
            let userHasInsuranceOnFile = true;  //keep this default to 'true' to avoid unnecessary showing of Insurance screen, incase of GetCoverage API failure
            let hasPendingSteps = false;
            let hasCompletedAnyStep = true;  //assume user has completed atleast one step of the onboarding flow
            let showInsuranceForm = false;
            let showFamilyMembersScreen = false;
            let showNotificationsScreen = false;
            let showScheduleCareTooltip = false;
            let userAge = domain.pu?.ay || domain.age;
            let isUserMinor = userAge && userAge < 18;
            let isProxyUser = domain.ip;
            let hasRedirect = reDirectURL ? reDirectURL !== '/' : false;
            let isMyChartStatusActive = false;
            logAPI("MBHWeb.Saga.SSO.Onboarding.IsUserMinor", start, null, isUserMinor);
            logAPI("MBHWeb.Saga.SSO.Onboarding.IsProxyUser", start, null, isProxyUser);
            logAPI("MBHWeb.Saga.SSO.Onboarding.HasRedirect", start, null, hasRedirect);

            //Get userInsuranceInfo from API
            const patientId = currentUser ? currentUser.epi : null;
            const userInsuranceInfo = patientId && (yield Tools.safeCall(account.getUserInsuranceInfo, token, patientId));
            logAPI("MBHWeb.Saga.SSO.GetUserInsuranceInfo", start, null, { patientId, userInsuranceInfo });

            if (userInsuranceInfo && !userInsuranceInfo.err && userInsuranceInfo.result) {
                userHasInsuranceOnFile = userInsuranceInfo.result.Coverage && userInsuranceInfo.result.Coverage.length > 0 && userInsuranceInfo.result.Coverage.some(coverage => coverage.Status.toUpperCase() === 'ACTIVE');
            }


            //get current active user patient profile from membership profile
            const activePatientProfile = yield select((state) => state.memberships.activeProfile?.patient);
            const isUserNonPatientProxy = activePatientProfile && (activePatientProfile.AMRN === null || !activePatientProfile.AMRN);  //if AMRN is null or undefined, user is a non-patient proxy

            //Validate Mychart Status before loading capture insurance.
            if (hasMyChart && !isUserMinor && !userHasInsuranceOnFile && !isUserNonPatientProxy && activePatientProfile && isAllPreferenceSuccess && userPreferenceList) {
                const userHasTodoCaptureInsuranceIndex = userPreferenceList.findIndex(preference => preference.PreferenceName.toUpperCase() === "SHOWCAPTUREINSURANCEFORM");
                const userHasTodoCaptureInsurance = userHasTodoCaptureInsuranceIndex > -1 ? userPreferenceList[userHasTodoCaptureInsuranceIndex].PreferenceValue === "true" : false;
                const mychartIdRsp = activePatientProfile.PatientIds.filter(id => id.IDType === 'MYCHARTLOGIN');
                const myChartID = mychartIdRsp && mychartIdRsp.length ? mychartIdRsp[0].ID.trim() : '';
                if (myChartID && token && userHasTodoCaptureInsurance) {
                    const myChartStatusResponse = yield Tools.safeCall(checkMyChartStatus, myChartID, 'MYCHARTLOGIN', token);
                    isMyChartStatusActive = myChartStatusResponse && myChartStatusResponse.result && myChartStatusResponse.result.result && myChartStatusResponse.result.result.MyChartStatusText
                        && myChartStatusResponse.result.result.MyChartStatusText.toLowerCase() === 'activated' ? true : false;
                }
            }

            if (isAllPreferenceSuccess && !hasRedirect && !isProxyUser) {
                try {

                    const onBoardingSteps = ['SHOWCAPTUREINSURANCEFORM', 'SHOWFAMILYMEMBERSSCREEN', 'SHOWNOTIFICATIONSSCREEN', 'SHOWSCHEDULECARETOOLTIP'];

                    const foundAtleastOneKey = userPreferenceList.some(prefObj => onBoardingSteps.includes(prefObj.PreferenceName.toUpperCase()));
                    let pendingSteps = userPreferenceList.filter(prefObj => onBoardingSteps.includes(prefObj.PreferenceName.toUpperCase()) && prefObj.PreferenceValue.toUpperCase() === 'TRUE');
                    pendingSteps = pendingSteps && pendingSteps.map(prefObj => prefObj.PreferenceName.toUpperCase());

                    let completedSteps = userPreferenceList.filter(prefObj => (onBoardingSteps.includes(prefObj.PreferenceName.toUpperCase()) && prefObj.PreferenceValue.toUpperCase() === 'FALSE')
                        || (prefObj.PreferenceName.toUpperCase() === "HASSEENEMAILOPTIN" && prefObj.PreferenceValue.toUpperCase() === 'TRUE'));
                    completedSteps = completedSteps && completedSteps.map(prefObj => prefObj.PreferenceName.toUpperCase());
                    logAPI("MBHWeb.Saga.SSO.Onboarding.CompletedSteps", start, null, completedSteps);
                    logAPI("MBHWeb.Saga.SSO.Onboarding.PendingSteps", start, null, pendingSteps);

                    //some user accounts were created even before the 'CaptureInsuranceForm' preference key was created.
                    //For such users, consider them to have completed atleast one step of the onboarding flow, if this Pref Key is not available
                    let userWasCreatedBeforeInsurancePref = userPreferenceList.findIndex(preference => preference.PreferenceName.toUpperCase() === "SHOWCAPTUREINSURANCEFORM") < 0;

                    hasPendingSteps = foundAtleastOneKey && (pendingSteps && pendingSteps.length > 0);
                    hasCompletedAnyStep = (completedSteps && completedSteps.length > 0) || (userWasCreatedBeforeInsurancePref);

                    if (hasPendingSteps) {
                        showInsuranceForm = pendingSteps.includes('SHOWCAPTUREINSURANCEFORM') && hasMyChart && !isUserMinor && !userHasInsuranceOnFile && !isUserNonPatientProxy;
                        showFamilyMembersScreen = pendingSteps.includes('SHOWFAMILYMEMBERSSCREEN') && hasMyChart && !isUserMinor;
                        showNotificationsScreen = pendingSteps.includes('SHOWNOTIFICATIONSSCREEN');
                        showScheduleCareTooltip = pendingSteps.includes('SHOWSCHEDULECARETOOLTIP') ? false : false;//Disabling Tooltip
                        let showOnboardingModal = false;

                        //show the onboarding modal only if the Terms call is successful and the user has accepted the terms
                        //do not show the onboarding modal if there is only one pending step and that is the 'ScheduleCareTooltip' step
                        if (!terms.err && terms.result && terms.result.isSuccessful)
                            showOnboardingModal = terms.result.isAccepted && !(pendingSteps.length === 1 && showScheduleCareTooltip) ? true : false;


                        yield put({ type: types.SHOW_ONBOARDING_MODAL, showOnboardingModal: showOnboardingModal });
                        yield put({ type: types.SHOW_INSURANCE_FORM, showInsuranceForm: showInsuranceForm });
                        yield put({ type: types.SHOW_FAMILYMEMBERS_SCREEN, showFamilyMembersScreen: showFamilyMembersScreen });
                        yield put({ type: types.SHOW_NOTIFICATIONS_SCREEN, showNotificationsScreen: showNotificationsScreen });
                        yield put({ type: types.SHOW_SCHEDULE_CARE_TOOLTIP, showScheduleCareTooltip: showScheduleCareTooltip });
                        logAPI("MBHWeb.Saga.SSO.Onboarding.ShowSteps", start, null, { showInsuranceForm, showFamilyMembersScreen, showNotificationsScreen, showScheduleCareTooltip });
                    }
                    yield put({ type: types.HAS_COMPLETED_ONBOARDING, hasCompletedOnboarding: !hasPendingSteps });
                }
                catch (e) {
                    logAPI("MBHWeb.Saga.SSO.Onboarding.Exception", start, null, e);

                }
            }

            // We separate this call out because this is what handles the ui update after logging in.
            // we need token and membership data before we switch the domain.li flag to true
            // this also turns off the login spinner

            // moved this to after the new onboarding logic as it was causing a delay in between setting the user as logged in and the redirect to '/'
            domain = yield select((state) => state.domain);
            var localStorage = yield select((state) => state.localStorage);
            //debugger;
            if (domain.li || true) // we actually have the ability to end up hear, while being logged out from somewhere else... this was causing a re-login without performing this check
            {
                yield put({
                    type: types.USER_AUTHENTICATE_ISLOGGEDIN,
                    userData: response,
                });
            }
            else {
                //return;
            }


            // For Thrive Preference       
            let showThriveTooltip = false;
            if (isAllPreferenceSuccess) {
                const indexThrivePref = userPreferenceList.findIndex(preference => preference.PreferenceName === msgs.ShowThriveTooltip);
                if (indexThrivePref >= 0) {
                    if (userPreferenceList[indexThrivePref].PreferenceValue === "true") {
                        showThriveTooltip = true;
                        yield put({
                            type: types.SHOW_THRIVE_TOOLTIP, showThriveTooltip
                        });
                    }
                    else {
                        showThriveTooltip = false;
                        yield put({
                            type: types.SHOW_THRIVE_TOOLTIP, showThriveTooltip
                        });
                    }
                    logAPI("MBHWeb.Saga.SSO.showThriveTooltip.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexThrivePref])));
                }
                //preference not found in the list of Preferences so we are showing ThriveTooltip.
                else {
                    showThriveTooltip = true;
                    yield put({
                        type: types.SHOW_THRIVE_TOOLTIP, showThriveTooltip
                    });
                }
            }

            // We can also route from here to terms and conditions, the marketing email opt in page, or capture insurance page
            if (typeof window !== 'undefined') {
                if (!terms.err && terms.result && terms.result.isSuccessful) {
                    if (!termsAccepted && !isMobile) { /*** Begin Terms Not Accepted **/

                        //If the user has not yet accepted the Terms, and not completed atleast one step of onboarding flow, consider them as a brand new user
                        //And, set all Onboarding V2 preferences to be true, so that the entire V2 Onboarding screens/tooltips are shown
                        //The sequence for the V2 Onboarding flow is --> 1. Accept terms, 2. Capture Insurance, 3. Family Members, 4. Notifications
                        if (!useRegistrationForUserPrefs) {
                            if (isAllPreferenceSuccess && !hasCompletedAnyStep) {
                                if (!hasRedirect && !isProxyUser) {
                                    //new user is considered to not have completed any onboarding steps
                                    showInsuranceForm = hasMyChart && !isUserMinor && !userHasInsuranceOnFile && !isUserNonPatientProxy;
                                    showFamilyMembersScreen = hasMyChart && !isUserMinor;
                                    showNotificationsScreen = true;
                                    showScheduleCareTooltip = false; //Disabling tooltip

                                    yield put({ type: types.SHOW_INSURANCE_FORM, showInsuranceForm: showInsuranceForm });
                                    yield put({ type: types.SHOW_FAMILYMEMBERS_SCREEN, showFamilyMembersScreen: showFamilyMembersScreen });
                                    yield put({ type: types.SHOW_NOTIFICATIONS_SCREEN, showNotificationsScreen: showNotificationsScreen });
                                    yield put({ type: types.SHOW_SCHEDULE_CARE_TOOLTIP, showScheduleCareTooltip: showScheduleCareTooltip });
                                    logAPI("MBHWeb.Saga.SSO.Onboarding.NewUser.ShowSteps", start, null, { showInsuranceForm, showFamilyMembersScreen, showNotificationsScreen, showScheduleCareTooltip });
                                    console.log("MBHWeb.Saga.SSO.Onboarding.NewUser.ShowSteps ", { showInsuranceForm, showFamilyMembersScreen, showNotificationsScreen, showScheduleCareTooltip });

                                    //set preference value for the above preference keys to be 'true' in the database                             
                                    yield put({ type: types.INITIALIZE_ONBOARDING_PREFERENCES });

                                }
                                else {

                                    /****** Review Comment: If the user !hasCompletedAnyStep but does hasRedirect or isProxyUser, 
                                    would still want to update the preference table but not show the onboarding screens during this login session. ****/

                                    //set preference value for the above preference keys to be 'true' in the database                               
                                    yield put({ type: types.INITIALIZE_ONBOARDING_PREFERENCES });

                                }
                            }
                        }


                        if (window.location.pathname !== "/login") {
                            // Write this as the new redirect URL (in case we refreshed after deleting login cookie)

                            yield put({ type: types.SET_REDIRECT_URL, URL: window.location.pathname });
                        }
                        if (history) {
                            history.push({
                                pathname: '/onboarding/acceptterms'
                            })
                        };

                        if (hasPendingSteps && !hasRedirect && showInsuranceForm && isMyChartStatusActive) {
                            yield put({ type: types.SET_REDIRECT_URL, URL: "/onboarding/captureinsurance" });
                        } else if (hasPendingSteps && !hasRedirect && showFamilyMembersScreen) {
                            yield put({ type: types.SET_REDIRECT_URL, URL: "/onboarding/familymembers" });
                        } else if (hasPendingSteps && !hasRedirect && showNotificationsScreen) {
                            yield put({ type: types.SET_REDIRECT_URL, URL: "/onboarding/managenotifications" });
                        }

                    }  /**** END Terms Not Accepted ***/

                    else if (hasPendingSteps && !hasRedirect && showInsuranceForm && isMyChartStatusActive) {
                        if (history) { history.push({ pathname: "/onboarding/captureinsurance" }) };
                    } else if (hasPendingSteps && !hasRedirect && showFamilyMembersScreen) {
                        if (history) { history.push({ pathname: "/onboarding/familymembers" }) };
                    } else if (hasPendingSteps && !hasRedirect && showNotificationsScreen) {
                        if (history) { history.push({ pathname: "/onboarding/managenotifications" }) };
                    }
                    else if (reDirectURL) {
                        yield handleRedirect(reDirectURL);
                    }
                    else if (window.location.pathname === "/login") {
                        if (history) {
                            //debugger; 
                            history.push("/");
                        };
                    }
                }
                else if (reDirectURL) {
                    yield handleRedirect(reDirectURL);
                }
                else if (window.location.pathname === "/login") {
                    if (history) {
                        //debugger;
                        history.push("/");
                    };
                }
            }

            if (response.callback) {
                response.callback();
            }

            // load translation list
            // Change sprefix value to take from GETHealthPlans, if we have mutiple health plans linked.

            //var tblPrefix = window.serverData.data.loginPrefixTable.split("|");
            // var tblLogins = domain.l.split(",");
            var sPrefix = currentHealthPlan && currentHealthPlan.APIPrefix ? currentHealthPlan.APIPrefix : null;

            //We found healthplan but didn't have prefix.
            if (currentHealthPlan && !sPrefix) {
                logAPI("MBHWeb.Saga.SSO.GetHealthPlan.PrefixNotFound", start, null);
            }

            //tblPrefix.forEach(sPrefixPart => {
            //    tblLogins.forEach(sLogin => {
            //        if (sPrefixPart.toLowerCase().indexOf(sLogin.toLowerCase() + ":") > -1) {
            //            sPrefix = sPrefixPart.substr(sPrefixPart.indexOf(":") + 1);
            //        }
            //    })
            //});

            if (window.location.href.toLocaleLowerCase().includes("localhost")) {
                if (sPrefix == "HR") {
                    yield put({ type: types.SET_HP_PREFIX, prefix: sPrefix });
                    window.serverData.data.hpServicesSpecificUrl = Tools.buildUrl(window.serverData.data.hpServicesUrl, "");
                }
                if (sPrefix === "WTPA") {
                    yield put({ type: types.SET_HP_PREFIX, prefix: sPrefix });
                    window.serverData.data.hpServicesSpecificUrl = Tools.buildUrl(window.serverData.data.hpGatewayUrl, "");
                }
                if (sPrefix === "AMI") {
                    yield put({ type: types.SET_HP_PREFIX, prefix: sPrefix });
                    var url = window.serverData.data.hpGatewayUrl.toLowerCase().replace("wtpa", sPrefix.toLowerCase());
                    window.serverData.data.hpServicesSpecificUrl = Tools.buildUrl(url, "");
                }
            }
            else if (sPrefix) {
                yield put({ type: types.SET_HP_PREFIX, prefix: sPrefix });
                let url = window.serverData.data.hpGatewayUrl.toLowerCase().replace("wtpa", sPrefix.toLowerCase());
                window.serverData.data.hpServicesSpecificUrl = Tools.buildUrl(url, "");
            }



            try {
                if (sPrefix && sPrefix === "AMI") {
                    const hpPayerId = domain.hi;
                    const isUserPayer = yield getUserPayerData(token, hpPayerId);
                    // Pass this data object off to a reducer here
                    yield put({ type: types.HP_AMI_ISUSERPAYER_SUCCESS, isUserPayer: isUserPayer });
                }
            }
            catch (e) {
                logAPI("MBHWeb.Saga.SSO.getUserPayerData.Failure", start, null);
            }
            try {
                if (sPrefix) {
                    const userData = yield getFCHPUserData(token, sPrefix);
                    // Pass this data object off to a reducer here
                    if (userData) {
                        yield put({ type: types.HP_USERDATA_SUCCESS, hpUserIdentity: userData });
                    }
                }
            }
            catch (e) {
                logAPI("MBHWeb.Saga.SSO.GetFCHPUserData.Failure", start, null);
            }

            // No waiting on these calls... just fire them off and let the results land where they will
            yield put({ type: types.THRIVE_GET_CARD, token: token });
            yield put({ type: types.GET_FAVORITE_PROVIDERS_START });

            //Add get user tile to load when linkage success. 
            yield put({
                type: types.LOAD_HEALTHSOURCEDASHBOARD_START
            });
            yield fork(loadNotices, hasMyChart, hasHealthPlan);
            const enableNewHealthPlan = window && window.serverData.data.enableNewHealthPlan;
            if (enableNewHealthPlan) {
                //Call health plan dashboard, if we user has health plan and not have auto role
                if (currentHealthPlan && currentHealthPlan.LoginProvider && !currentHealthPlan.Auto) {
                    yield put({ type: types.LOAD_HEALTHPLAN_DATA_START });
                }
            }
            else {
                if (domain.aal) {
                    yield put({ type: types.LOAD_HEALTHPLAN_DATA_START });
                }
            }

            //yield put({ type: types.DIRECT_SCHEDULING_PROVIDER_LIST, searchModel: { loginId: domain.un, proxyPatientId: domain.cu ? domain.cu.ei : null }, token: domain.t });
            // yield fork(loadEvisit, response); // <--- commented because we are now getting eVisit from the proxyInfo call which is called via loadProxyList (see below)

            //Clearing current user and primary user in header reducer to reflect updated value when do linking and unlinking process for mychart.
            //yield put({
            //    type: types.RESET_USER_VALUE
            //});
            yield all([
                call(loadThrive, response),  // we have to wait for Thrive info for proper rednering of the menu system
                showAccessAndProxiesList && call(loadCurrentManagers, response, hasMyChart) //waiting to load current managers of current user.
            ]);

            domain = yield select((state) => state.domain);
            const dashboardState = yield select((state) => state.dashboard);
            const bundle = typeof window !== 'undefined' && window.serverData.data.bundle ? window.serverData.data.bundle.toLowerCase() : '';

            let isSeeAllSelected = false

            if (dashboardState && dashboardState.isShowAllUsers === null && bundle === 'mybswhealth') {
                if (domain && domain.pl && domain.pu && domain.pu.dn && domain.cu && domain.cu.dn && domain.pu.dn.toLowerCase() === domain.cu.dn.toLowerCase()) {
                    if (domain.pl.length > 1) { //check length greater than 1, due to primary user added in pl array.
                        yield put({ type: types.LOAD_DASHBOARD_SEE_ALL_VIEW });
                        isSeeAllSelected = true;
                    } else {
                        yield put({ type: types.RESET_DASHBOARD_SEE_ALL_VIEW });
                    }
                } else {
                    yield put({ type: types.RESET_DASHBOARD_SEE_ALL_VIEW });
                }
            } else {
                isSeeAllSelected = bundle === 'mybswhealth' && dashboardState ? dashboardState.isShowAllUsers : false;
            }

            yield put({ type: types.LOAD_BFF_DASHBOARD_START, isSeeAllSelected: isSeeAllSelected });

            //Moving this down becuase its requires proxy patient id.
            if (domain && domain.cu && domain.cu.ei) {
                yield put({ type: types.DIRECT_SCHEDULING_PROVIDER_LIST, searchModel: { loginId: domain.un, proxyPatientId: domain.cu.ei }, token: domain.t });
                logAPI("MBHWeb.Saga.SSO.OnUserAuthenticateSuccess.Schedule.GetProviderList.Start", start, null);
            } else {
                logAPI("MBHWeb.Saga.SSO.OnUserAuthenticateSuccess.Schedule.GetProviderList.NotLoaded", start, null);
            }

            logAPI("MBHWeb.Saga.SSO.OnUserAuthenticateSuccess", start, null);
        }
        else {
            console.error("MBHWeb.Saga.SSO.OnUserAuthenticateSuccess.Failure", response);
            logAPI("MBHWeb.Saga.SSO.OnUserAuthenticateSuccess.Failure", start, null);
            yield put({ type: types.USER_AUTHENTICATE_FAILURE, userData: response, errorCode: response && response.error_code ? response.error_code : null, userErrorMessage: response && response.user_message ? response.user_message : null, responseError: response.error_description ? response.error_description : response.error && response.error === "invalid_grant" ? msgs.LoginInvalidGrantMessage : response.error, isWaiting: false });
        }
    }
    catch (err) {
        //debugger;
        console.error("MBHWeb.Saga.SSO.OnUserAuthenticateSuccess.FailureCatch", err);
        yield put({ type: types.AJAX_CALL_ERROR, error: err, isWaiting: false });
        logAPI("MBHWeb.Saga.SSO.OnUserAuthenticateSuccess.Failure", start, null, err);
    }
}


export function* checkMyChartStatus(myChartId, myChartIdType, token) {
    const start = new Date();
    try {
        const myChartStatusRsp = yield Tools.safeCall(getMyChartStatus, myChartId, myChartIdType, token);
        logAPI("MBHWeb.Saga.SSO.CheckMyChartStatus.Success", start, null, myChartStatusRsp);
        return myChartStatusRsp;
    } catch (err) {
        logAPI("MBHWeb.Saga.SSO.CheckMyChartStatus.Failure", start, null, err);
    }
    return null;
}


export function* refreshFamilyManagementTooltip() {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        const session = yield select((state) => state.session);

        var token = domain.t;
        // check for all preferences of the user
        const allPreferences = yield Tools.safeCall(account.getAllUserPreferences2, token);
        //debugger;
        const isAllPreferenceSuccess = allPreferences && !allPreferences.err && allPreferences.result;
        const userPreferenceList = isAllPreferenceSuccess && allPreferences.result.preferenceList ? allPreferences.result.preferenceList : [];
        if (isAllPreferenceSuccess) {
            logAPI("MBHWeb.Saga.SSO.GetAllUserPreferences.Get", start, null, JSON.parse(JSON.stringify(allPreferences.result)));
        }
        else {
            logAPI("MBHWeb.Saga.SSO.GetAllUserPreferences.Get.Failure", start, null, allPreferences);
        }

        // For Family Management Preference           
        if (isAllPreferenceSuccess) {
            const indexFamilyManagementToolTipPref = userPreferenceList.findIndex(preference => preference.PreferenceName === msgs.ShowFamilyManagementToolTip);
            const showFamMgmtTooltip = indexFamilyManagementToolTipPref >= 0 ? userPreferenceList[indexFamilyManagementToolTipPref].PreferenceValue === "true" : true;
            if (showFamMgmtTooltip && !session.hasRedirect) {
                yield put({
                    type: types.SHOW_FAMILY_MANAGEMENT_TOOLTIP, showFamilyManagementToolTip: false //Disabling tooltip
                });
            }
            else {
                yield put({
                    type: types.SHOW_FAMILY_MANAGEMENT_TOOLTIP, showFamilyManagementToolTip: false
                });
            }

            if (indexFamilyManagementToolTipPref >= 0) {
                logAPI("MBHWeb.Saga.SSO.FamilyManagementToolTip.Preference.Get", start, null, JSON.parse(JSON.stringify(userPreferenceList[indexFamilyManagementToolTipPref])));
            }
        }
    }
    catch (err) {
        logAPI("MBHWeb.Saga.SSO.FamilyManagementToolTip.Preference.Get.Failure", start, null, err);
    }
}

export function* verifyLogin(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        const ssoResponse = yield call(isLoggedInPost2, domain.t);

        const loggedin = ssoResponse.IsLoggedIn;
        if (loggedin === false) {
            console.log("LOGOUT");
            yield put({ type: types.LOGOUT, userDetails: {}, DontClearRedirectURL: payload.DontClearRedirectURL, fromWindowListener: true });
            logAPI("MBHWeb.Saga.SSO.VerifyLogin", start, null);
        }
        else {
            //debugger;
            yield onUserAuthenticateSuccess({ ...ssoResponse, callback: payload.callback });
            if (payload.forceRefresh) {

                yield put({ type: types.REFRESH_TOKEN });  // this allows us to refresh any changes that may have been to the account by an external site
            }
        }
        yield put({ type: types.VERIFY_LOGIN_COMPLETED });
        if (payload.callback) {
            try {
                payload.callback();
            }
            catch (e) {
            }
        }
    }
    catch (error) {
        console.error("MBHWeb.Saga.SSO.VerifyLogin.Failure", error);
        logAPI("MBHWeb.Saga.SSO.VerifyLogin.Failure", start, null, JSON.stringify(error));
        yield put({ type: types.VERIFY_LOGIN_COMPLETED });
        yield put({ type: types.AJAX_CALL_ERROR, error: error, isWaiting: false });
    }
}

export function* logoutRedirect(data) {
    const start = new Date();
    try {
        //debugger;
        console.info(`ssoSaga logoutRedirect`);
        // clear proxy on logout
        const sDomain = getDomain();
        Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
        Cookies.set("AuthToken" + window.serverData.data.environment, "", { path: '/', domain: sDomain });

        //reset the value for 'hasSeenScheduleCareTooltip to false
        yield put({ type: types.HAS_SEEN_SCHEDULE_CARE_TOOLTIP, hasSeenScheduleCareTooltip: false });
        yield put({ type: types.CLEAR_MAMMOGRAPHY_FLOW_SELECTED_OPTION });
        const history = yield select((state) => state.session.history);
        try {
            const domain = yield select((state) => state.domain);
            Cookies.expire('location_' + domain.un, { domain: Tools.getDomain(location.href) });
            Tools.clearItemFromSessionStorage('insurance_' + domain.un);
            //const covidScreeningModalKey = window && window.serverData.data.showCOVID19ModalPerUser ? domain.cu && domain.cu.dn && domain.cu.eid ? domain.un + '_' + domain.cu.dn + '_' + domain.cu.eid : domain.un : domain.un;           
            Tools.clearItemFromSessionStorageWithStrContains(msgs.CovidScreeningModalSessionKeyInitial + domain.un);  // using domain.un and not  covidScreeningModalKey as we want to clean key for primary as well as its proxies.
            Tools.clearItemFromSessionStorageWithStrContains(msgs.MammogramCovid19ModalSessionKeyInitial);
            if (Tools.getItemFromSessionStorage('captureInsuranceForm')) {
                Tools.clearItemFromSessionStorage('captureInsuranceForm');
            }

            //delete localStorage items related to healthplan search criteria persisting
            Object.keys(localStorage).forEach((key) => {
                try {
                    let item = JSON.parse(localStorage.getItem(key));
                    if (item.expire === "ONLOGOUT") {
                        localStorage.removeItem(key);
                    }
                }
                catch (e) { }
            });
        }
        catch (e) { console.log(e); }

        yield put({ type: types.INITIAL_STATE_DASHBOARD_SEE_ALL_VIEW });

        yield put({ type: types.LOGOUT_COMPLETED, logoutMessage: data.logoutMessage }); // this forces the UI to update

        // Notify other windows
        try {
            if (data.fromWindowListener == null || !data.fromWindowListener) {
                //debugger;
                localStorage.setItem("logoutFrom", window.serverData.data.appInstanceID);
                //window.postMessage({ logout: true, appInstanceID: window.serverData.data.appInstanceID });
            }
        }
        catch (e) {

        }


        if (window.location.pathname !== "/login" && !data.DontClearRedirectURL && window.location.pathname !== "/reset") {
            try {
                //alert("Manually switching to Login page");
                if (history) { history.push("/login") };
            }
            catch (ex) {
                console.error(ex);
                logAPI("MBHWeb.Saga.SSO.LogoutRedirect.Failure", start, null, JSON.stringify(ex));
            }

        }

        yield prayerFeatureSaga.cleanupUserSession();

        logAPI("MBHWeb.Saga.SSO.LogoutRedirect", start, null);
        yield put({ type: types.USER_LOGGED_OUT, DontClearRedirectURL: data.DontClearRedirectURL, logoutMessage: data.logoutMessage });


    }
    catch (err) {
        console.error(err);
        logAPI("MBHWeb.Saga.SSO.LogoutRedirect.Failure", start, null, JSON.stringify(err));
    }
}

function* refreshProxyList(data) {
    const userDetails = yield select((state) => state.sso.userDetails);
    const domain = yield select((state) => state.domain);
    // check if user is even able to have proxies. if so, refresh profile. if not, send proxy list loaded. 
    if (userDetails && domain.hm) {
        yield refreshProfileData(data); // we short circuit here, since we don't need the call anymore
    } else {
        yield put({ type: types.NO_USER_PROXY });
        yield put({ type: types.PROXY_LIST_LOADED, proxyList: [] });
        if (data && data.callback) {
            data.callback([], false);
        }
    }
}


function* loadThrive(userDetails) {
    const start = new Date();
    try {
        const thrive = yield call(getThrive, userDetails.access_token);
        yield put({ type: types.THRIVE, thrive });
        logAPI("MBHWeb.Saga.SSO.LoadThrive", start, null);
    }
    catch (getThriveError) {
        //console.error(getThriveError);
        logAPI("MBHWeb.Saga.SSO.LoadThrive.Failure", start, null, JSON.stringify(getThriveError));
    }
}

function* loadEvisit(userDetails) {
    try {
        const eVisit = yield call(getEvisitEligibility, userDetails.userName, userDetails.access_token);
        yield put({ type: types.EVISIT, eVisit });
        //logToAndylitics(dDate, dDate, 'MBHWeb.Evisits.Start', null, null, null, '/SSOEvisit');
        logToAndylitics('MBHWeb.Evisits.Start', new Date(), '/SSOEvisit');
    }
    catch (getEvisitEligibilityError) {
        //console.error(getEvisitEligibilityError);
        logToAndylitics('MBHWeb.Evisits.Start.Failure', new Date(), '/SSOEvisit');
    }
}

function* zipnosisEvisitUrl(data) {
    const start = new Date();
    const { token, userName, zipGroupId, patientId, patientIdType, subUrl } = data;
    try {
        if (token && userName) {
            let url = yield call(getZipnosisEvisitUrl, token, userName, zipGroupId, patientId, patientIdType);
            if (subUrl) {
                const index = url.indexOf('?');
                url = url.substr(0, index) + '/' + subUrl + (subUrl.indexOf('?') === -1 ? '?' : '&') + url.substr(index + 1);
            }
            yield put({ type: types.ZIPNOSIS_EVISIT_URL_SUCCESS, url });
            logAPI("MBHWeb.Saga.SSO.ZipnosisEvisitUrl", start, null);
        }
    }
    catch (error) {
        if (typeof error === 'string') {
            const zipnosisError = yield call(convertZipnosisErrorMessage, error);
            const { errorMessage, errorMessageName } = zipnosisError;
            yield put({ type: types.ZIPNOSIS_EVISIT_URL_FAILURE, errorMessage, errorMessageName });
        }
        else {
            yield put({ type: types.ZIPNOSIS_EVISIT_URL_FAILURE, errorMessage: 'Unknown error', errorMessageName: '' });
        }
        console.log('getZipnosisEvisitUrl error: ', error);
        logAPI("MBHWeb.Saga.SSO.ZipnosisEvisitUrl.Failure", start, null, JSON.stringify(error));
    }
}

function* handleUserSwitch(payload) {
    yield call(careCompanion, payload && payload.user && payload.user.externalId);
}

function* careCompanion(externalId) {
    if (externalId) {
        const domain = yield select((state) => state.domain);
        try {
            const response = yield call(getCareCompanionEnrollStatus, domain.t, externalId);
            yield put({ type: types.MEMBERSHIP_CARE_COMPANION, enabled: response && response.CareCompanionEnrolled });
            logAPI("MBHWeb.Saga.SSO.CareCompanionEnrollStatus.Success", new Date(), null, response, externalId);
        }
        catch (error) {
            yield put({ type: types.MEMBERSHIP_CARE_COMPANION, enabled: false });
            logAPI("MBHWeb.Saga.SSO.CareCompanionEnrollStatus.Failure", new Date(), null, error, externalId);
        }
    }
    else {
        yield put({ type: types.MEMBERSHIP_CARE_COMPANION, enabled: false });
        logAPI("MBHWeb.Saga.SSO.CareCompanionEnrollStatus", new Date(), null, null, 'no external id');
    }
}

function* loadNotices(hasMyChart, hasHealthPlan) {
    const start = new Date();
    try {
        const notices = yield call(getNotices, true, hasMyChart, hasHealthPlan);
        if (notices) {
            yield put({ type: types.NOTICES_LOGGED_IN, notices: notices });
            logAPI("MBHWeb.Saga.SSO.LoadNotices", start, null);
        }
    }
    catch (getNoticesError) {
        //console.error(getNoticesError);
        logAPI("MBHWeb.Saga.SSO.LoadNotices.Failure", start, null, JSON.stringify(getNoticesError));
    }
}

function* loadCurrentManagers(userDetails, hasMyChart) {
    const start = new Date();

    try {
        if (userDetails && hasMyChart) {
            try {
                yield put({ type: types.LOAD_CURRENT_MANAGERS_PENDING });
                const response = yield call(getEpicWhoCanManageYou, userDetails.access_token, userDetails.userName);
                const managers = response && response.Proxies && response.Proxies.length > 0 ? response.Proxies : [];
                const currManagerList = [];
                const now = new Date();
                for (let i = 0; i < managers.length; i++) {
                    const item = managers[i];
                    if (!item.ToDate || new Date(item.ToDate) >= now) {
                        const patientId = item.PatientIds.filter(id => id.IDType === 'EXTERNAL');
                        const externalId = patientId && patientId.length ? patientId[0].ID.trim() : null;
                        const internal = item.PatientIds.filter(id => id.IDType === 'INTERNAL');
                        const mychartId = item.PatientIds.filter(id => id.IDType === 'MYCHARTLOGIN');
                        const eid = item.PatientIds.filter(id => id.IDType === 'EID');
                        const relId = item.RelationshipID;
                        const epi = item.PatientIds.filter(id => id.IDType === 'EPI');
                        const expireDate = item.ToDate;
                        currManagerList.push({
                            displayName: item.ProxyName.trim(),
                            externalId,
                            internalId: internal && internal.length ? internal[0].ID.trim() : null,
                            myChartId: mychartId && mychartId.length ? mychartId[0].ID.trim() : "",
                            eid: eid && eid.length ? eid[0].ID.trim() : null,
                            relationshipId: relId,
                            index: i,
                            item,
                            epi: epi && epi.length ? epi[0].ID.trim() : null,
                            expireDate
                        });
                    }
                }
                yield put({ type: types.LOAD_CURRENT_MANAGERS_SUCCESS, currManagerList: currManagerList });
                logAPI("MBHWeb.Saga.SSO.LoadCurrentManagers", start, null);

            }
            catch (response) {
                console.error(response);
                if (response.status !== 401) {
                    yield put({ type: types.LOAD_CURRENT_MANAGERS_FAILURE });
                    logAPI("MBHWeb.Saga.SSO.LoadCurrentManagers.Failure", start, null);
                }
            }
        }
        else {
            yield put({ type: types.LOAD_CURRENT_MANAGERS_SUCCESS, currManagerList: [] });
        }
    }
    catch (error) {
        yield put({ type: types.LOAD_CURRENT_MANAGERS_FAILURE });
        logAPI("MBHWeb.Saga.SSO.LoadCurrentManagers.Failure", start, null, JSON.stringify(error));
    }
}